import React from "react";
import { Form, DatePicker, Mentions, Input, Icon, Button, Table } from 'antd';
import moment from 'moment';
import Widget from '../../Components/Theme/Widget';


const FormItem = Form.Item;

/**
 * A form that is used to search for a live schedule. It has two inputs, a dropdown to search for a schedule by date
 and a date picker for the start date.
 */
 class SelectLiveScheduleForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
            autoCompleteResult: [],
            searchValue: ''
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
       this.props.handleLiveScheduleSubmit()
    };

    // handleConfirmBlur = (e) => {
    //     const value = e.target.value;
    //     this.setState({confirmDirty: this.state.confirmDirty || !!value});
    // };

    handleChange = (e) => {
        this.props.returnSearchValue(e.target.value);
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 24},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 24},
            },
        };

            return (

                <Form onSubmit={this.handleSubmit}>

                    <FormItem
                        {...formItemLayout}
                    >
                        {
                                !this.props.liveScheduleSearch ?
                                    (
                                        <div>
                                            <Input
                                                onClick={this.testClick}
                                                name="resourceCollection"
                                                placeholder={'Select a Schedule'}
                                                onMouseDown={this.props.handleLiveScheduleSearch}
                                                onChange={this.props.handleLiveScheduleSelect}
                                                value={this.props.selectedLiveSchedule.name}
                                                size={'large'}
                                                required
                                                suffix={<Icon type={this.props.liveScheduleSearch ? 'up' : 'down'}/>}
                                            />
                                        </div>
                                    )
                          :
                            <Input
                                type="text"
                                name="searchValue"
                                allowClear
                                required
                                defaultValue={this.state.searchValue}
                                onChange={this.handleChange}
                            ></Input>
                        }
                    </FormItem>

                    <FormItem
                        {...formItemLayout}
                    >
                        <div style={{ marginTop: 10 }}>
                            <Mentions  style={{ marginRight: 10, border: "none", width: 120 }} placeholder="Start Date" readOnly/>
                            <DatePicker
                                onChange={this.props.handleLiveDateChange}
                                defaultValue={moment()}
                                format={'MM-DD-YYYY'}
                                required
                                popupStyle={{ zIndex: 2000 }}
                            />
                        </div>
                    </FormItem>

                    {   this.props.liveScheduleSearch &&
                        (
                           <Widget>
                                <Table
                                    columns={this.props.columns}
                                    dataSource={this.props.dataSource}
                                    size="small"
                                    onRow={record => ({
                                        onClick: (e) => this.props.handleLiveScheduleSelect(record)
                                    })}
                                />
                        </Widget>
                        )
                    }

                    <FormItem {...formItemLayout}>
                        <Button type="submit" block size={'small'} htmlType="submit">Submit</Button>
                    </FormItem>

                </Form>
            );
    }
}

export const WrappedSelectLiveScheduleForm = Form.create()(SelectLiveScheduleForm);




// WEBPACK FOOTER //
// ./src/Components/Schedule/SelectLiveScheduleForm.js